// @flow
import { takeEvery, put, call } from 'redux-saga/effects';

import { getResource, getArrayResource } from '@redux/components/ApiRequest/actions';
import { changeTitle } from '@redux/components/Metadata/actions';
import { pageReady } from '@redux/components/Page/actions';

import { mainApiUrl } from '@lib';

import {
  COMPANY_DETAILS_REQUEST,
  FACILITIES_DETAILS_REQUEST,
  COMPANY_DETAILS_UPDATE
} from './constants';
import {
  updateCompanyDetails,
  errorCompanyDetails,
  updateFacilitiesDetails,
  errorFacilitiesDetails
} from './actions';

import type { Action } from '../types';

export function* companyDetailsRequestFlow({ slug }: Action): Generator<Function, void, void> {
  if (!slug) return;

  const url: string = `${mainApiUrl}/v1/facility_groups/${slug}`;
  yield put(getResource(url, updateCompanyDetails, errorCompanyDetails));
}

export function* companyDetailsUpdateFlow(action: Action): Generator<Function, void, void> {
  const title: ?string = (action?.data: any)?.attributes?.name;

  yield put(changeTitle({ IN: { en: title } }));
  yield put(pageReady());
}

export function* facilityDetailsRequestFlow({
  id,
  perPage
}: Action): Generator<Function, void, void> {
  if (!id) return;

  const params: {} = { company_id: id, per_page: perPage };
  const url: string = `${mainApiUrl}/v1/facility_groups`;

  yield put(getArrayResource(url, updateFacilitiesDetails, errorFacilitiesDetails, { params }));
}

export function* companyDetailsFlow(action: Action): Generator<Function, void, void> {
  switch (action.type) {
    case COMPANY_DETAILS_REQUEST:
      yield call(companyDetailsRequestFlow, action);
      break;

    case FACILITIES_DETAILS_REQUEST:
      yield call(facilityDetailsRequestFlow, action);
      break;

    case COMPANY_DETAILS_UPDATE:
      yield call(companyDetailsUpdateFlow, action);
      break;

    default:
      break;
  }
}

export default function* companyDetailsWatcher(): Generator<Function, void, Action> {
  yield takeEvery(
    [COMPANY_DETAILS_REQUEST, FACILITIES_DETAILS_REQUEST, COMPANY_DETAILS_UPDATE],
    companyDetailsFlow
  );
}
